<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Centro de Custo</h5>
                        <button type="button" class="close" @click="fechar_modal()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="alert alert-info d-flex justify-content-between" v-if="item && item.procedimento">
                            <div>{{ item.procedimento.search }}
                                <div class="small" v-if="item.centro_selec">
                                    {{ item.centro_selec.st_sigla }} | {{ item.centro_selec.st_nome }}
                                </div>
                            </div>
                            <div>#{{ item.id_atendimento }}</div>
                        </div>

                        <div class="alert alert-info d-flex justify-content-between" v-if="item && item.id_atendimento_procedimento_consumo">
                            <div>{{ item.search }}
                                <div class="small" v-if="item.centro_selec">
                                    {{ item.centro_selec.st_sigla }} | {{ item.centro_selec.st_nome }}
                                </div>
                            </div>
                            <div v-if="item.id_atendimento">#{{ item.id_atendimento }}</div>
                        </div>

                        <az-input
                            sizing="sm"
                            icon="fa-solid fa-location-dot fa-fw"
                            type="autocomplete"
                            placeholder="Selecione o Centro de Custo..."
                            service="centro_custos.index"
                            v-model="novo_centro_custo"
                            required
                            :validate="validate">
                        </az-input>

                        <br><br><br><br><br><br><br><br><br><br>

                        <pre v-if="false">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal()">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="selecionar()" v-if="apenas_selecao">Selecionar</button>
                        <az-submit @click="atualizar()" v-else>Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'; 
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return { 
            item: null, 
            novo_centro_custo: "", 
            modal_id: "", 
            validate: false, 
            apenas_selecao: false, 
            item_original: null,
        };
    },

    components: { 
        AzInput,
        AzSubmit
    },

    computed: { 
        modal_name: function() { 
            return 'alterarCentroCustoModal' + this.modal_id;
        }
    },
    
    methods: { 
        fechar_modal() { 
            $('#' + this.modal_name).modal('hide');
        },

        abrir (item, apenas_selecao = false) { 
            this.item_original = item; 
            this.apenas_selecao = apenas_selecao;
            this.validate = false; 
            this.item = _.cloneDeep(item);
            this.novo_centro_custo = "";

            $('#' + this.modal_name).modal('show');
        },

        selecionar() { 
            this.item_original.id_centro_custo = this.novo_centro_custo ? this.novo_centro_custo.id_centro_custo : null;
            this.item_original.centro = this.novo_centro_custo;
            this.fechar_modal();
        },

        atualizar() { 
            this.$util.atualizar(this, {
                service: 'atendimentos',  
                func: 'alterar_centro_custo_item', 
                dados: { 
                    id_atendimento_procedimento: this.item.id_atendimento_procedimento, 
                    id_atendimento_procedimento_consumo: this.item.id_atendimento_procedimento_consumo, 
                    id_centro_custo: this.novo_centro_custo ? this.novo_centro_custo.id_centro_custo : null,  
                },
                modal: this.modal_name, 
                toast: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        }
    },

    mounted() { 
        this.modal_id = this.$util.uuidv4();
    }    
}
</script>
